export default __webpack_public_path__ + "db669a66bf84cec59658434716205a76.svg";